import React from "react";
import { githubLanguages } from "./filterDefaults";
import LanguageSearchSelect from "./LanguageSearchSelect";

const setField = (onChange, filters) => (key) => (e) =>
  onChange({ ...filters, [key]: e.target.value });

const FilterSidebar = ({ mode, filters, onChange, onApply, onClear, hideTitle }) => {
  const set = setField(onChange, filters);
  const isRepo = mode === "repositories";

  const setLanguage = (lang) => onChange({ ...filters, language: lang });

  return (
    <div className="gf-filter-sidebar__inner">
      {!hideTitle && (
        <h2 className="gf-filter-sidebar__title">Filters</h2>
      )}

      <div className="gf-filter-sidebar__actions gf-filter-sidebar__actions--top">
        <button type="button" className="gf-btn gf-btn--primary gf-btn--block" onClick={onApply}>
          Apply filters
        </button>
        <button type="button" className="gf-btn gf-btn--outline gf-btn--block" onClick={onClear}>
          Clear all
        </button>
      </div>

      <div className="gf-filter-sidebar__group">
        <h3 className="gf-filter-sidebar__heading">Language &amp; activity</h3>
        <label className="gf-label gf-label--sidebar">
          Language
          <LanguageSearchSelect
            value={filters.language}
            onChange={setLanguage}
            languages={githubLanguages}
            idPrefix="gf-sidebar-lang"
          />
        </label>

        <label className="gf-label gf-label--sidebar gf-label--sidebar-spaced">
          Last push / update
          <select
            className="gf-input gf-select"
            value={filters.lastActive}
            onChange={set("lastActive")}
          >
            <option value="">Any</option>
            <option value="30d">Last 30 days</option>
            <option value="6m">Last 6 months</option>
            <option value="1y">Last year</option>
          </select>
        </label>

        <label className="gf-label gf-label--sidebar">
          Topic
          <input
            className="gf-input"
            value={filters.topic}
            onChange={set("topic")}
            placeholder="e.g. react, ml"
          />
        </label>
      </div>

      {!isRepo && (
        <div className="gf-filter-sidebar__group">
          <h3 className="gf-filter-sidebar__heading">Profile</h3>
          <label className="gf-label gf-label--sidebar">
            Username
            <input
              className="gf-input"
              value={filters.usernameExact}
              onChange={set("usernameExact")}
              placeholder="@octocat"
            />
          </label>
          <label className="gf-label gf-label--sidebar">
            Name keyword
            <input
              className="gf-input"
              value={filters.nameKeyword}
              onChange={set("nameKeyword")}
            />
          </label>
          <div className="gf-row2">
            <label className="gf-label gf-label--sidebar">
              Followers min
              <input
                type="number"
                min="0"
                className="gf-input"
                value={filters.followersMin}
                onChange={set("followersMin")}
              />
            </label>
            <label className="gf-label gf-label--sidebar">
              Followers max
              <input
                type="number"
                min="0"
                className="gf-input"
                value={filters.followersMax}
                onChange={set("followersMax")}
              />
            </label>
          </div>
          <label className="gf-label gf-label--sidebar">
            Following min
            <input
              type="number"
              min="0"
              className="gf-input"
              value={filters.followingMin}
              onChange={set("followingMin")}
            />
          </label>
          <label className="gf-label gf-label--sidebar">
            Public repos min
            <input
              type="number"
              min="0"
              className="gf-input"
              value={filters.publicReposMin}
              onChange={set("publicReposMin")}
            />
          </label>
        </div>
      )}

      {isRepo && (
        <div className="gf-filter-sidebar__group">
          <h3 className="gf-filter-sidebar__heading">Stars &amp; forks</h3>
          <div className="gf-row2">
            <label className="gf-label gf-label--sidebar">
              Stars min
              <input
                type="number"
                min="0"
                className="gf-input"
                value={filters.minStars}
                onChange={set("minStars")}
              />
            </label>
            <label className="gf-label gf-label--sidebar">
              Stars max
              <input
                type="number"
                min="0"
                className="gf-input"
                value={filters.maxStars}
                onChange={set("maxStars")}
              />
            </label>
          </div>
          <label className="gf-label gf-label--sidebar">
            Forks min
            <input
              type="number"
              min="0"
              className="gf-input"
              value={filters.forksMin}
              onChange={set("forksMin")}
            />
          </label>
          <label className="gf-label gf-label--sidebar">
            Repo / readme keyword
            <input
              className="gf-input"
              value={filters.repoNameKeyword}
              onChange={set("repoNameKeyword")}
            />
          </label>
        </div>
      )}

      {!isRepo && (
        <div className="gf-filter-sidebar__group">
          <h3 className="gf-filter-sidebar__heading">Repositories</h3>
          <label className="gf-label gf-label--sidebar">
            Repo / readme keyword
            <input
              className="gf-input"
              value={filters.repoNameKeyword}
              onChange={set("repoNameKeyword")}
            />
          </label>
        </div>
      )}

      <p className="gf-filter-sidebar__hint gf-filter-sidebar__hint--foot">
        Use <strong>Sort</strong> in the results bar to reorder.
      </p>
    </div>
  );
};

export default FilterSidebar;
